import React, { useEffect } from "react";
import { useToastContext, type Toast } from "./toast-context";
import "./toast.scss";

const ToastItem: React.FC<{ toast: Toast }> = ({ toast }) => {
  const { removeToast } = useToastContext();

  useEffect(() => {
    if (toast.duration && toast.duration > 0) {
      const timer = setTimeout(() => {
        removeToast(toast.id);
      }, toast.duration);
      return () => clearTimeout(timer);
    }
  }, [toast, removeToast]);

  return (
    <div className="toast-item">
      <span className="toast-message">{toast.message}</span>
      <button
        onClick={() => removeToast(toast.id)}
        className="toast-close"
      >
        ✕
      </button>
    </div>
  );
};

export const ToastContainer: React.FC = () => {
  const { toasts } = useToastContext();

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <div key={toast.id}>
          <ToastItem toast={toast} />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
